import { render, staticRenderFns } from "./ShopingHome.vue?vue&type=template&id=3afe1e86&scoped=true"
import script from "./ShopingHome.vue?vue&type=script&lang=js"
export * from "./ShopingHome.vue?vue&type=script&lang=js"
import style0 from "./ShopingHome.vue?vue&type=style&index=0&id=3afe1e86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afe1e86",
  null
  
)

export default component.exports